import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getMockBillingPolicyAccepted,
  USE_MOCK_BILLING_ACCEPT,
} from "../constants/billingPolicyMock";
import { setPortalTermsAccepted } from "../store/user/actions";
import { RootState } from "../store/combineReducer";

/**
 * TEMP: keeps mock billing gating in sync with sessionStorage,
 * overriding redux-persist stale portalTermsAccepted values.
 */
export const useSyncMockBillingPolicy = () => {
  const dispatch = useDispatch();
  const currentRole = useSelector((state: RootState) => state.user.currentRole);

  useEffect(() => {
    if (!USE_MOCK_BILLING_ACCEPT || currentRole !== "COMPANY_ADMIN") return;

    dispatch(setPortalTermsAccepted(getMockBillingPolicyAccepted()));
  }, [currentRole, dispatch]);
};

export const isPortalAccessBlocked = (
  portalTermsAccepted: boolean | null | undefined,
): boolean => portalTermsAccepted !== true;
